import { Validator } from '@vista-digital/validator';
export const defaultFilmActorsDisplayText = {
    label: 'Cast'
};
export const filmActorsDisplayTextValidatorSchema = {
    label: Validator.nonEmptyString
};
export const filmActorsDisplayTextValidator = Validator.object(filmActorsDisplayTextValidatorSchema);
//# sourceMappingURL=display-text.js.map